exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n@keyframes shadow-fade {\nfrom {\n    box-shadow: 0 0 4px #919191;\n}\nto {\n    box-shadow: 0 0 0 #dfdfdf;\n}\n}\n.diff-file.is-active {\n  box-shadow: 0 0 0 #dfdfdf;\n  animation: shadow-fade 1.2s 0.1s 1;\n}\n", ""]);

